import './date-picker.scss'

import { FormApi } from 'final-form';
import { get, set } from 'lodash'
import { DateTime } from 'luxon'
import Component from 'vue-class-component';

import { DATE_FORMATS, buildSkinDateWithFormat, toFormat } from '@skinsoft/utils'
import { ReactiveVue } from '@skinsoft/reactive-vue'

@Component({
    props: ['form', 'name'],
    template: require('./date-picker.html'),
})
export class DatePicker extends ReactiveVue {

    public dateValue: string = "";
    public form: FormApi;
    public name: string;

    public mounted() {
        // Filling date picker with value
        const defaultValue = get(this.form.getState().values, this.name)
        if (defaultValue && defaultValue.startInterval.date) {
            this.dateValue = toFormat(defaultValue, DATE_FORMATS.YYYY_MM_DD_DASH)
        } else {
            // If reportDate is blank, set today's date
            this.dateValue = DateTime.now().toFormat(DATE_FORMATS.YYYY_MM_DD_DASH);
        }
    }

    /**
     * Generates a date suitable for backend data from the 
     * date-picker value
     */
    private get skinDate() {
        return buildSkinDateWithFormat(this.dateValue, DATE_FORMATS.YYYY_MM_DD_DASH);
    }

    private onValueChange() {
        // Modifying directly form value, converting to skin date
        set(this.form.getState().values, this.name, this.skinDate)
    }
}